import { render, staticRenderFns } from "./BookingReceipts.vue?vue&type=template&id=bd7a89ca&"
import script from "./BookingReceipts.vue?vue&type=script&lang=js&"
export * from "./BookingReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports